import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import useQuery from '../../../hooks/useQuery'
import QUERY_KEYS from '../../../graphql/queryKeys'
import clientImportRowsQuery from '../../../graphql/queries/clientImportRows'
import { captureErrorAndNotify } from '../../../utilities/errorHandlers'
import { Spinner } from '../../../pages/shared/Spinner'

export default function ErrorRows ({ importId, pluralImportName }) {
  const { data: clientImportRowsData, isLoading } = useQuery(
    [QUERY_KEYS.clientImportRows, {
      clientImportId: importId,
      status: 'IMPORT_ERROR',
      first: 10
    }],
    clientImportRowsQuery,
    {
      onError (error) {
        captureErrorAndNotify(error, 'Failed to retrieve data')
      },
      // We don't usually consider data to not be stale, BUT in this scenario this query gets loaded from a few components within a short time span
      // AND this data never changes. Once an import starts, its rows do not change.
      staleTime: 5 * 1000 * 60
    })

  if (isLoading) {
    return <Spinner isFetching />
  }

  return (
    <div className='my-8'>
      {clientImportRowsData.clientImportRows.nodes.map((row) => (
        <div className='flex justify-start items-center p-2' key={row.id} style={{ backgroundColor: '#ffe3e7' }}>
          <i className='material-icons text-red opacity-80 text-3xl mr-4'>info</i>
          <span className='font-medium'>
            <span className={styles.capitalize}>{pluralImportName}</span> {row.name} failed to be created.&nbsp;
            {row.importError}
          </span>
        </div>
      ))}
    </div>
  )
}

ErrorRows.propTypes = {
  importId: PropTypes.string.isRequired,
  pluralImportName: PropTypes.string.isRequired
}
